import { render, staticRenderFns } from "./NotificationDemo.vue?vue&type=template&id=4f51b124"
import script from "./NotificationDemo.vue?vue&type=script&lang=js"
export * from "./NotificationDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports